import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import StyledTextVariant from "%/dynamic-components/render-engine/options/text-options/styled-text-variant";
import TextStyleOption from "%/dynamic-components/render-engine/options/text-options/text-style-option";
import TextOption from "%/dynamic-components/render-engine/options/text-options/text-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class BrandedTextOptions extends BaseOptionsBundle {

  optionTitle = "Styled Text";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "styled-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.STYLED_TEXT_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      TextStyleOption,
      StyledTextVariant,
      TextOption,
    ]);
  }
}
